import TextField from "@mui/material/TextField";
import axios from "axios";
import React, { useState } from "react";
import { urlServerNotifications } from "../utils/UrlServerAdmin";
import BackdropComponent from "../components/CargaComponents/BackdropComponent";
import EmojiPicker from "emoji-picker-react";
import { Button } from "@mui/material";

const EnviarNotificaciones = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [showEmojiPickerTitle, setShowEmojiPickerTittle] = useState(false);
  const [showEmojiPickerBody, setShowEmojiPickerBody] = useState(false);
  const [showEmojiPickerMensaje, setShowEmojiPickerMensaje] = useState(false);

  const handleOpenEmojiPicker = (inputName: string) => {
    if (inputName === "title") {
      showEmojiPickerTitle
        ? setShowEmojiPickerTittle(false)
        : setShowEmojiPickerTittle(true);
    }
    if (inputName === "body") {
      showEmojiPickerBody
        ? setShowEmojiPickerBody(false)
        : setShowEmojiPickerBody(true);
    }
    if (inputName === "mensaje") {
      showEmojiPickerMensaje
        ? setShowEmojiPickerMensaje(false)
        : setShowEmojiPickerMensaje(true);
    }


  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    console.log("Error mensaje: ", mensaje);

    try {
      const response = await axios.post(
        `${urlServerNotifications}sendNotification`,
        {
          title,
          body,
          data: {
            mensaje: mensaje,
          },
        }
      );
      if (response.status === 200) {
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Error al enviar notificaciones: ", error);
      alert("error al enviar notificaciones");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading && <BackdropComponent enabled={isLoading} />}

      <h2>ENVIAR NOTIFICACIONES A LOS SOCIOS EN GENERAL</h2>
      <br />
      <p className="text-justify">
        Al ingresar texto en los campos requeridos se enviara un mensaje a los
        socios registrados en general, ingresa cada uno de los campos y presiona
        enviar para mostrarse en la pantalla de los dispositivos de los socios.
      </p>
      <br />
      <h3 className="text-success">
        Procede a llenar los campos requeridos y envía una notificación
      </h3>

      <form className="" onSubmit={handleSubmit} method="post">
        {/* -------------------------Seccion para el titulo--------------------------- */}
        <div className="d-flex align-items-center h-100 w-100">
          <TextField
            id="outlined-basic"
            label="Ingresa el título de la notificación"
            variant="outlined"
            className="w-75 mt-3"
            onChange={(e) => setTitle(e.target.value)}
            value={title}
            onFocus={() => setShowEmojiPickerTittle(false)}
            required
          />
          <div className="d-flex flex-column h-100 justify-content-center align-items-center ms-3">
            <p className="mb-0">Seleccionar un emoji</p>
            <Button
              style={{ fontSize: "1.5rem" }}
              onClick={() => handleOpenEmojiPicker("title")}
              className="mt-0"
            >
              {showEmojiPickerTitle ? "❌" : "😀"}
            </Button>
          </div>
          <div>
            <EmojiPicker
              onEmojiClick={(emoji: any) => setTitle(title + emoji.emoji)}
              open={showEmojiPickerTitle}
              className="top-0 end-0"
              width={300}
            />
          </div>
        </div>

        {/* -------------------------Seccion para el subtitulo--------------------------- */}
        <div className="d-flex align-items-center h-100 w-100">
          <TextField
            id="outlined-basic"
            label="Ingresa un subtítulo para la notificación"
            variant="outlined"
            className="w-75"
            onChange={(e) => setBody(e.target.value)}
            value={body}
            onFocus={() => setShowEmojiPickerBody(false)}
            required
          />
          <div className="d-flex flex-column h-100 justify-content-center align-items-center ms-3">
            <p className="mb-0">Seleccionar un emoji</p>
            <Button
              style={{ fontSize: "1.5rem" }}
              onClick={() => handleOpenEmojiPicker("body")}
              className="mt-0"
            >
              {showEmojiPickerBody ? "❌" : "😀"}
            </Button>
          </div>
          <div>
            <EmojiPicker
              onEmojiClick={(emoji: any) => setBody(body + emoji.emoji)}
              open={showEmojiPickerBody}
              className="top-0 end-0"
              width={300}
            />
          </div>
        </div>
        {/* -------------------------Seccion para el mensaje --------------------------- */}
        <div className="d-flex align-items-center h-100 w-100">
          <TextField
            id="outlined-basic"
            label="Puedes ingresar un mensaje extenso para la notificación"
            variant="outlined"
            className="w-75"
            onChange={(e) => setMensaje(e.target.value)}
            value={mensaje}
            onFocus={() => setShowEmojiPickerMensaje(false)}
            required
            multiline
          />
          <div className="d-flex flex-column h-100 justify-content-center align-items-center ms-3">
            <p className="mb-0">Seleccionar un emoji</p>
            <Button
              style={{ fontSize: "1.5rem" }}
              onClick={() => handleOpenEmojiPicker("mensaje")}
              className="mt-0"
            >
              {showEmojiPickerMensaje ? "❌" : "😀"}
            </Button>
          </div>
          <div>
            <EmojiPicker
              onEmojiClick={(emoji: any) => setMensaje(mensaje + emoji.emoji)}
              open={showEmojiPickerMensaje}
              className="top-0 end-0"
              width={300}
            />
          </div>
        </div>

        <button
          className="btn btn-success w-50"
          disabled={isLoading}
          type="submit"
        >
          Enviar
        </button>
      </form>
    </div>
  );
};

export default EnviarNotificaciones;
